'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/intl-messageformat-parser/index.js
// module id = 198
// module chunks = 0 1 2 3 4 5 6